import React from "react";
import { useTranslation } from "react-i18next";
import { SubscriptionApi } from "../../../../../../../../services/Api/Subscription/subscriptionTypes";

interface Props {
	subscription: SubscriptionApi;
}

const SubscriptionUsageWarning = ({ subscription }: Props) => {
	const { t } = useTranslation();

	const getWarningMessage = () => {
		if (subscription.warning) {
			const { code, usage_value, max_value, feature } = subscription.warning;

			if (code === "invalid_subscription_for_usage") {
				switch (feature) {
					case "employee-limit":
						return t("modules.subscription.field.invalid_subscription_for_usage_employee.title", {
							maxValue: max_value,
							count: usage_value,
							plan: subscription.name,
						});
					default:
						return "";
				}
			}
		}
	};

	const message = getWarningMessage();
	if (message) return <div className={`d-inline-block text-danger my-2`}>{message}</div>;

	return <></>;
};

export default SubscriptionUsageWarning;
